import TradeRuleService from '../../../services/tradeRules.service';
import CourseService from '../../../services/courses.service';
import ProviderService from '../../../services/providers.service';
import axios from 'axios'

var CancelToken = axios.CancelToken;
var Source = null;

export const validateTradeRuleName = async (store, { ruleId, ruleName }) => {
    store.setState(prevState => ({
        ...prevState,
        TradeRule: {
            ...store.state.TradeRule
        },
    }))
    try {
        const data = await TradeRuleService().validateTradeRuleName(ruleId, ruleName)
        store.setState(prevState => ({
            ...prevState,
            TradeRule: {
                ...store.state.TradeRule,
                tradeRuleDetail: {
                    ...store.state.TradeRule.tradeRuleDetail,
                    ruleName: ruleName,
                    isRuleNameNotExist: data.data.errorMessage != "",
                    ruleErrorMessage: data.data.errorMessage
                },
            },
        }))
    }
    catch (error) {
        store.setState(prevState => ({
            ...prevState,
            TradeRule: {
                ...store.state.TradeRule,
                tradeRuleDetail: {
                    ...store.state.TradeRule.tradeRuleDetail,
                    isRuleNameExist: false,
                    ruleErrorMessage: '',
                }
            },
        }))
    }
}
export async function getCourses(store, { currentPage, pageSize, filters }) {
    try {
        const state = store.state;
        let newFilters = filters || state.TradeRule.tradeRuleCourseList.filters;
        pageSize = (!pageSize || pageSize <= 0) ? 1 : pageSize;
        let allSelected = state.TradeRule.tradeRuleCourseList.allSelected ? true : pageSize === state.TradeRule.tradeRuleCourseList.selectedCourses.length;
        allSelected = (newFilters.ruleId != state.TradeRule.tradeRuleDetail.tradeRuleId) ? false : allSelected;
        newFilters.ruleId = state.TradeRule.tradeRuleDetail.tradeRuleId;
        const fileterSelectAll = ((newFilters.name == "" && allSelected) ||
            (newFilters.provider == "" ||
                newFilters.provider == 0) && allSelected) ? false : allSelected;

        store.setState({
            TradeRule: {
                ...state.TradeRule,
                tradeRuleCourseList: {
                    ...state.TradeRule.tradeRuleCourseList,
                    allSelected: fileterSelectAll,
                    filters: newFilters,
                    pagination: { ...state.TradeRule.tradeRuleCourseList.pagination, pageSize },
                }
            }
        });

        if (Source) {
            Source.cancel();
        }
        Source = CancelToken.source();
        const { items, pagination } = await CourseService().getCourses(currentPage, pageSize, newFilters, Source.token);
        Source = null;
        store.setState({
            TradeRule: {
                ...store.state.TradeRule,
                tradeRuleCourseList: {
                    ...state.TradeRule.tradeRuleCourseList,
                    allSelected: fileterSelectAll,
                    items: items,
                    pagination: pagination,
                    filters: newFilters,
                }
            },
        });
    }
    catch (error) {
        if (axios.isCancel(error)) {
            console.log('request cancelled');
        }
        else {
            throw error;
        }
    }
}

export function setSelectPage(store, newSelectedValue) {
    const coursesToOperate = [...store.state.TradeRule.tradeRuleCourseList.items.map(course => course.id)];
    let newSelectedCourses = store.state.TradeRule.tradeRuleCourseList.selectedCourses;
    coursesToOperate.forEach(element => newSelectedCourses = getNewSelectedArray(newSelectedCourses, element, newSelectedValue));
    store.setState({
        TradeRule: {
            ...store.state.TradeRule,
            tradeRuleCourseList: {
                ...store.state.TradeRule.tradeRuleCourseList,
                selectedCourses: newSelectedCourses,
            }
        }
    });

}

export const setSelect = (store, { courseId, newSelectedValue }) => {
    const newSelectedCourses = getNewSelectedArray(store.state.TradeRule.tradeRuleCourseList.selectedCourses, courseId, newSelectedValue);
    const newSelectedCourseConfiguration = newSelectedValue ? store.state.TradeRule.tradeRuleCourseList.selectedCourseConfiguration : store.state.TradeRule.tradeRuleCourseList.selectedCourseConfiguration.filter(current => current.courseId !== courseId);
    store.setState({
        TradeRule: {
            ...store.state.TradeRule,
            tradeRuleCourseList: {
                ...store.state.TradeRule.tradeRuleCourseList,
                selectedCourses: newSelectedCourses,
                selectedCourseConfiguration: newSelectedCourseConfiguration
            }
        }
    });
}

export function setSelectAll(store, allSelected) {
    var selectedCourseDetails = [];
    var selectedAllCourseConfiguration = [];
    const filters = store.state.TradeRule.tradeRuleCourseList.filters;
    if (!allSelected && (filters.name || filters.provider != "")) {
        store.state.TradeRule.tradeRuleCourseList.selectedCourses.forEach(function (data) {
            const valueFilter = store.state.TradeRule.tradeRuleCourseList.items.filter(course => course.id == data).length;
            if (valueFilter === 0) {
                selectedCourseDetails.push(data);
            }
        })
        store.state.TradeRule.tradeRuleCourseList.selectedCourseConfiguration.forEach(function (data) {
            const valueFilter = store.state.TradeRule.tradeRuleCourseList.items.filter(course => course.id == data).length;
            if (valueFilter === 0) {
                selectedAllCourseConfiguration.push(data);
            }
        })

        if (selectedCourseDetails.length != selectedAllCourseConfiguration.length) {
            selectedCourseDetails = [];
            selectedAllCourseConfiguration = [];
        }
    }
    else {
        selectedCourseDetails = [];
        selectedAllCourseConfiguration = [];
    }

    store.setState({
        TradeRule: {
            ...store.state.TradeRule,
            tradeRuleCourseList: {
                ...store.state.TradeRule.tradeRuleCourseList,
                allSelected: allSelected,
                selectedCourses: !allSelected ? selectedCourseDetails : store.state.TradeRule.tradeRuleCourseList.selectedCourses,
                selectedCourseConfiguration: !allSelected ? selectedAllCourseConfiguration : store.state.TradeRule.tradeRuleCourseList.selectedCourseConfiguration,
            }
        }
    });
}

export function setSelectedTradeRuleCoursesCount(store) {
    const selectedTradeRuleCoursesCount = store.state.TradeRule.tradeRuleCourseList.selectedCourses.length;
    store.setState({
        TradeRule: {
            ...store.state.TradeRule,
            tradeRuleCourseList: {
                ...store.state.TradeRule.tradeRuleCourseList,
                selectedTradeRuleCoursesCount: selectedTradeRuleCoursesCount,
            }
        }
    });
}

export async function getClasses(store, id) {
    store.setState({ TradeRule: { ...store.state.TradeRule.tradeRuleCourseList, classes: [] } });
    const classes = await CourseService().getClasses(id);
    store.setState({
        TradeRule: {
            ...store.state.TradeRule,
            tradeRuleCourseList: {
                ...store.state.TradeRule.tradeRuleCourseList,
                classes: classes,
            }
        }
    });
}

function getNewSelectedArray(initialArray, id, newSelectedValue) {
    return newSelectedValue ?
        (initialArray.indexOf(id) !== -1 ? initialArray : [...initialArray, id]) :
        (initialArray.filter(currentId => currentId !== id))
}

export function checkClassConfig(store) {
    let isValidateCheckConfig = store.state.TradeRule.tradeRuleCourseList.selectedCourses.length == 0 ? false : true;
    isValidateCheckConfig = document.getElementsByClassName("rate-type-dropdown-error").length == 0 ? isValidateCheckConfig : false
    return store.setState({
        TradeRule: {
            ...store.state.TradeRule,
            tradeRuleCourseList: {
                ...store.state.TradeRule.tradeRuleCourseList,
                isValidateCheckConfig: isValidateCheckConfig,
            },
        }
    });
}

export function setSelectCourseConfiguration(store, { courseId, classIds, newSelectedValue }) {
    const newSelectedCourseConfiguration = getNewSelectedCourseConfigurationArray(store.state.TradeRule.tradeRuleCourseList.selectedCourseConfiguration, courseId, classIds, newSelectedValue, store.state.TradeRule.tradeRuleDetail.tradeRuleId);
    return store.setState({
        TradeRule: {
            ...store.state.TradeRule,
            tradeRuleCourseList: {
                ...store.state.TradeRule.tradeRuleCourseList,
                selectedCourseConfiguration: newSelectedCourseConfiguration,
            }
        }
    });
}

function getNewSelectedCourseConfigurationArray(initialArray, id, classIds, newSelectedValue, ruleId) {
    const courseDetailsList = initialArray.filter(current => current.courseId !== id);
    const previousConfig = initialArray.filter(current => current.courseId === id);
    return newSelectedValue ? [...courseDetailsList, {
        "courseId": id,
        "classIds": classIds,
        "tradeRuleCourseConfigurationId": previousConfig && previousConfig.length == 1 && previousConfig[0].tradeRuleCourseConfigurationId > 0 ? previousConfig[0].tradeRuleCourseConfigurationId : 0,
        "tradeRuleId": ruleId && ruleId > 0 ? ruleId : 0,
        "IsEnabled": true
    }] : courseDetailsList;
}

export async function getProviders(store) {
    const providers = await ProviderService().getAllProviders();
    store.setState({
        TradeRule: {
            ...store.state.TradeRule,
            tradeRuleCourseList: {
                ...store.state.TradeRule.tradeRuleCourseList,
                providers: providers,
            },
            tradeRuleCourseListProviders: providers,
        }
    });
}

export const saveTradeRuleCourseConfiguration = async (store, tradeRuleDetail) => {
    store.setState(prevState => ({
        ...prevState,
        TradeRule: {
            ...store.state.TradeRule,
            tradeRuleDetail: {
                ...store.state.TradeRule.tradeRuleDetail,
                ruleErrorMessage: "",
                tradeRuleCourseConfigurationExistList: []
            }
        },
    }))
    try {
        const data = await TradeRuleService().createTradeRule(tradeRuleDetail)
        store.setState(prevState => ({
            ...prevState,
            TradeRule: {
                ...store.state.TradeRule,
                tradeRuleDetail: {
                    ...store.state.TradeRule.tradeRuleDetail,
                    isValidTradeRuleCourseConfiguration: data.isValid,
                    ruleErrorMessage: data.errorMessage,
                    tradeRuleCourseConfigurationExistList: data.tradeRuleCourseConfigurationExistList,
                },
            },
        }))
    }
    catch (error) {
        store.setState(prevState => ({
            ...prevState,
            TradeRule: {
                ...store.state.TradeRule,
                tradeRuleDetail: {
                    ...store.state.TradeRule.tradeRuleDetail,
                    isValidTradeRuleCourseConfiguration: false,
                    ruleErrorMessage: '',
                    tradeRuleCourseConfigurationExistList: []
                }
            },
        }))
    }
}

export const checkTradeRuleCourseConfigurationExists = async (store, tradeRuleDetail) => {
    store.setState(prevState => ({
        ...prevState,
        TradeRule: {
            ...store.state.TradeRule,
            tradeRuleDetail,
        },
    }))
    try {
        const data = await TradeRuleService().checkTradeRuleCourseConfigurationExists(tradeRuleDetail)
        store.setState(prevState => ({
            ...prevState,
            TradeRule: {
                ...store.state.TradeRule,
                tradeRuleDetail: {
                    ...store.state.TradeRule.tradeRuleDetail,
                    isValidTradeRuleDetails: data.isValid,
                    ruleErrorMessage: data.errorMessage
                },
            },
        }))
    }
    catch (error) {
        store.setState(prevState => ({
            ...prevState,
            TradeRule: {
                ...store.state.TradeRule,
                tradeRuleDetail: {
                    ...store.state.TradeRule.tradeRuleDetail,
                    isRuleNameExist: false,
                    ruleErrorMessage: '',
                }
            },
        }))
    }
}

export const getTradeRuleWithCourseConfiguration = async (store, tradeRuleId) => {
    store.setState(prevState => ({
        ...prevState,
        TradeRule: {
            ...store.state.TradeRule,
            tradeRuleDetail: {
                ...store.state.TradeRule.tradeRuleDetail,
                ruleErrorMessage: "",
                tradeRuleCourseConfigurationExistList: []
            },
            tradeRuleCourseList: {
                ...store.state.TradeRule.tradeRuleCourseList,
                selectedCourseConfiguration: [],
                selectedCourses: []
            },
            isLoadingSelectedCourseClassInfomation: true,

        },
    }))
    try {
        const data = await TradeRuleService().getTradeRule(tradeRuleId)
        if (data && data.tradeRuleCourseConfigurations && data.tradeRuleCourseConfigurations.length > 0) {
            store.setState(prevState => ({
                ...prevState,
                TradeRule: {
                    ...store.state.TradeRule,
                    tradeRuleDetail: data,
                    tradeRuleCourseList: {
                        ...store.state.TradeRule.tradeRuleCourseList,
                        selectedCourseConfiguration: data.tradeRuleCourseConfigurations,
                        selectedCourses: data.tradeRuleCourseConfigurations.map(course => course.courseId)
                    }
                },
            }))
        }
    }
    catch (error) {
        store.setState(prevState => ({
            ...prevState,
            TradeRule: {
                ...store.state.TradeRule,
                selectedCourseClassInfomation: null,
                tradeRuleDetail: {
                    ...store.state.TradeRule.tradeRuleDetail,
                    isValidTradeRuleCourseConfiguration: false,
                    ruleErrorMessage: '',
                    tradeRuleCourseConfigurationExistList: []
                }
            },
        }))
    }
}

export const updateTradeRuleCourseConfiguration = async (store, tradeRuleDetail) => {
    store.setState(prevState => ({
        ...prevState,
        TradeRule: {
            ...store.state.TradeRule,
            selectedCourseClassInfomation: null,
            isLoadingSelectedCourseClassInfomation: true,
            tradeRuleDetail: {
                ...store.state.TradeRule.tradeRuleDetail,
                ruleErrorMessage: "",
                tradeRuleCourseConfigurationExistList: []
            }
        },
    }))
    try {

        if (tradeRuleDetail && tradeRuleDetail.listTradeRuleCourseConfiguration && tradeRuleDetail.listTradeRuleCourseConfiguration.length > 0) {
            Object.keys(tradeRuleDetail).forEach(key => {
                if (tradeRuleDetail[key] === null) {
                    delete tradeRuleDetail[key];
                }
            });

            tradeRuleDetail.listTradeRuleCourseConfiguration.forEach(obj => {
                Object.keys(obj).forEach(key => {
                    if (obj[key] === null) {
                        delete obj[key];
                    }
                })
            });
        }

        const data = await TradeRuleService().saveTradeRule(tradeRuleDetail)
        store.setState(prevState => ({
            ...prevState,
            TradeRule: {
                ...store.state.TradeRule,
                tradeRuleDetail: {
                    ...store.state.TradeRule.tradeRuleDetail,
                    isValidTradeRuleCourseConfiguration: data.isValid,
                    ruleErrorMessage: data.errorMessage,
                    tradeRuleCourseConfigurationExistList: data.tradeRuleCourseConfigurationExistList,
                },
            },
        }))
    }
    catch (error) {
        store.setState(prevState => ({
            ...prevState,
            TradeRule: {
                ...store.state.TradeRule,
                tradeRuleDetail: {
                    ...store.state.TradeRule.tradeRuleDetail,
                    isValidTradeRuleCourseConfiguration: false,
                    ruleErrorMessage: '',
                    tradeRuleCourseConfigurationExistList: []
                }
            },
        }))
    }
}

export async function updateStoreValues(store) {
    store.setState(prevState => ({
        ...prevState,
        TradeRule: {
            ...store.state.TradeRule,
            isLoadingSelectedCourseClassInfomation: false,
            tradeRuleDetail: {
                ...store.state.TradeRule.tradeRuleDetail,
                isValidTradeRuleCourseConfiguration: false,
                ruleErrorMessage: '',
                tradeRuleCourseConfigurationExistList: []
            },
            tradeRuleCourseList: {
                ...store.state.TradeRule.tradeRuleCourseList,
                pagination: {
                    ...store.state.TradeRule.tradeRuleCourseList.pagination,
                    currentPage: 1,
                },
            }
        },
    }))
}

export async function resetTradeRuleDetails(store) {
    store.setState({
        TradeRule: {
            ...store.state.TradeRule,
            selectedCourseClassInfomation: null,
            tradeRuleDetail: {
                courseSelected: "",
                ruleId: 0,
                tradeRuleId: 0,
                ruleName: '',
                discount: 0,
                numOfRounds: 0,
                isMonday: false,
                isTuesday: false,
                isWednesday: false,
                isThursday: false,
                isFriday: false,
                isSaturday: false,
                isSunday: false,
                startTime: "",
                endTime: "",
                startDate: new Date(),
                endDate: new Date(),
                isEnabled: true,
                rateTypeLabel: "",
                teesheetNotes: "",
                isRuleNameNotExist: false,
                isValidTradeRuleDetails: false,
                ruleErrorMessage: '',
                listTradeRuleCourseConfiguration: [],
                tradeRuleCourseConfigurationExistList: [],
                isValidTradeRuleCourseConfiguration: false,
            },
            tradeRuleCourseList: {
                pagination: {
                    currentPage: 1,
                    pageSize: 10,
                    pagesCount: 1,
                    itemsCount: 0
                },
                filters: {
                    name: '',
                    provider: '',
                    status: 1,
                    isClassReq: true,
                },
                items: [],
                selectedCourses: [],
                selectedCourseConfiguration: [],
                selectedTradeRuleCoursesCount: 0,
                allSelected: false,
                isValidateCheckConfig: false,
            },
        }
    });
}

export const getCourseClassInfoByRuleId = async (store, tradeRuleId) => {
    store.setState(prevState => ({
        ...prevState,
        TradeRule: {
            ...store.state.TradeRule,
            isLoadingSelectedCourseClassInfomation: true,
            selectedCourseClassInfomation: null,
        },
    }))
    try {
        const data = await TradeRuleService().getCourseClassInfoByRuleId(tradeRuleId)
        store.setState(prevState => ({
            ...prevState,
            TradeRule: {
                ...store.state.TradeRule,
                selectedCourseClassInfomation: data,
                isLoadingSelectedCourseClassInfomation: false,
            },
        }))
    }
    catch (error) {
        store.setState(prevState => ({
            ...prevState,
            TradeRule: {
                ...store.state.TradeRule,
                selectedCourseClassInfomation: null,
                isLoadingSelectedCourseClassInfomation: false,
            },
        }))
    }
}

